import { autoinject, inject, bindable, DOM, bindingMode } from 'aurelia-framework';
import { ValidationController, ValidationRules, validateTrigger, Validator } from 'aurelia-validation';

@autoinject()
export class HorizontalTextInput {

    constructor(private element: Element) {
    }

    @bindable({ defaultBindingMode: bindingMode.oneWay }) readonly: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) value: string;
    @bindable({ defaultBindingMode: bindingMode.oneTime }) name: string;
    @bindable({ defaultBindingMode: bindingMode.oneTime }) label: string;
    @bindable({ defaultBindingMode: bindingMode.oneTime }) placeholder: string;

    bind() {
        this.name = this.name || HorizontalTextInput.getGuid();
    }

    static getGuid(): string {
        // see: http://stackoverflow.com/a/2117523/91189
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    //triggerEvent = (type:string) => this.element.dispatchEvent(DOM.createCustomEvent(type, {}));

}